import React from 'react';

import type {RunWithRunsetInfo} from '../../../state/runs/types';
import {conditionalRunOrGroupLink} from '../../../util/runhelpers';
import {DEFAULT_COLUMN_WIDTH} from './CellDimensionsSelector';

export type CellProps = {
  run: RunWithRunsetInfo;
  disableRunLinks: boolean;
  runSetEntityName: string;
  runSetProjectName: string;
  color?: string;
  columnWidth?: number;
  displayName: string;
};

export const CellNew = ({
  run,
  runSetEntityName,
  runSetProjectName,
  disableRunLinks,
  color,
  columnWidth = DEFAULT_COLUMN_WIDTH,
  displayName,
}: CellProps) => {
  const runLink = conditionalRunOrGroupLink(
    run,
    runSetEntityName,
    runSetProjectName,
    displayName,
    color
  );

  return (
    <div
      className="cell-new name-cell-new night-aware line-clamp-1 flex-shrink-0 flex-grow basis-0"
      title={displayName}
      // color needs to be defined in both parent and child for ellipses to be colored correctly, lol
      style={{color, width: columnWidth, minWidth: columnWidth}}>
      {disableRunLinks ? displayName : runLink}
    </div>
  );
};
